export default __webpack_public_path__ + "static/media/no-avatar.e586cc3b.svg";